import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Http from "../../Common/Http";
import { isPrivilegedUser } from "../../Common/permissions";

const Workplace = ({ onMenuClick, active }) => {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    Http.get("/me")
      .then((res) => setCurrentUser(res.data?.data || res.data))
      .catch((err) => console.error("Error fetching current user:", err));
  }, []);

  // Only admins and department heads can see the task calendars.
  const privileged = isPrivilegedUser(currentUser);

  return (
    <>
      <li className="nav-item">
        <Link
          to
          className={`nav-link with-sub ${
            active === "/region" || active === "/area" || active === "/base" || active === "/route" ? "active show-sub" : ""
          }`}
        >
          <i className="fa fa-briefcase" aria-hidden="true"></i>
          <span>Project Management</span>
        </Link>
        <ul className="nav-sub">
          {/* Project */}
          <li className="nav-item">
            <Link
              to="/list-project"
              className={`nav-link ${active === "/list-project" ? "active" : ""}`}
              onClick={() => onMenuClick("/list-project")}
            >
              <i className="fa fa-clone" aria-hidden="true"></i>
              &nbsp;&nbsp; Projects
            </Link>
          </li>

          {/* Task Type */}
          <li className="nav-item">
            <Link
              to="/list-type-task"
              className={`nav-link ${active === "/list-type-task" ? "active" : ""}`}
              onClick={() => onMenuClick("/list-type-task")}
            >
              <i className="fa fa-clone" aria-hidden="true"></i>
              &nbsp;&nbsp; Task Type
            </Link>
          </li>

          {/* Label */}
          <li className="nav-item">
            <Link to="/list-label" className={`nav-link ${active === "/list-label" ? "active" : ""}`} onClick={() => onMenuClick("/list-label")}>
              <i className="fa fa-clone" aria-hidden="true"></i>
              &nbsp;&nbsp; Label
            </Link>
          </li>

          {/* Story */}
          <li className="nav-item">
            <Link to="/list-story" className={`nav-link ${active === "/list-story" ? "active" : ""}`} onClick={() => onMenuClick("/list-story")}>
              <i className="fa fa-clone" aria-hidden="true"></i>
              &nbsp;&nbsp; Story
            </Link>
          </li>

          {/* Sprint */}
          <li className="nav-item">
            <Link to="/sprint-list" className={`nav-link ${active === "/sprint-list" ? "active" : ""}`} onClick={() => onMenuClick("/sprint-list")}>
              <i className="fa fa-calendar" aria-hidden="true"></i>
              &nbsp;&nbsp; Sprint
            </Link>
          </li>

          {/* Sprint Planning */}
          <li className="nav-item">
            <Link
              to="/sprint-planning"
              className={`nav-link ${active === "/sprint-planning" ? "active" : ""}`}
              onClick={() => onMenuClick("/sprint-planning")}
            >
              <i className="fa fa-tasks" aria-hidden="true"></i>
              &nbsp;&nbsp; Sprint Planning
            </Link>
          </li>

          {/* Task */}
          <li className="nav-item">
            <Link to="/list-task" className={`nav-link ${active === "/list-task" ? "active" : ""}`} onClick={() => onMenuClick("/list-task")}>
              <i className="fa fa-clone" aria-hidden="true"></i>
              &nbsp;&nbsp; Task
            </Link>
          </li>

          {/* Backlog (replacing separate Story and Task) */}
          <li className="nav-item">
            <Link to="/backlog" className={`nav-link ${active === "/backlog" ? "active" : ""}`} onClick={() => onMenuClick("/backlog")}>
              <i className="fa fa-list" aria-hidden="true"></i>
              &nbsp;&nbsp; Backlog
            </Link>
          </li>

          {/* Project Board */}
          <li className="nav-item">
            <Link
              to="/list-project-board"
              className={`nav-link ${active === "/list-project-board" ? "active" : ""}`}
              onClick={() => onMenuClick("/list-project-board")}
            >
              <i className="fa fa-clone" aria-hidden="true"></i>
              &nbsp;&nbsp; Project Board
            </Link>
          </li>

          {/* Task Calendar (admins / heads only) */}
          {privileged && (
            <li className="nav-item">
              <Link
                to="/task-calendar"
                className={`nav-link ${active === "/task-calendar" ? "active" : ""}`}
                onClick={() => onMenuClick("/task-calendar")}
              >
                <i className="fa fa-calendar" aria-hidden="true"></i>
                &nbsp;&nbsp; Task Calendar
              </Link>
            </li>
          )}

          {/* Task Calendar (New) (admins / heads only) */}
          {privileged && (
            <li className="nav-item">
              <Link
                to="/task-calendar-v2"
                className={`nav-link ${active === "/task-calendar-v2" ? "active" : ""}`}
                onClick={() => onMenuClick("/task-calendar-v2")}
              >
                <i className="fa fa-calendar-check-o" aria-hidden="true"></i>
                &nbsp;&nbsp; Task Calendar (New)
              </Link>
            </li>
          )}

          {/* Developer Task History */}
          <li className="nav-item">
            <Link
              to="/developer-task-history"
              className={`nav-link ${active === "/developer-task-history" ? "active" : ""}`}
              onClick={() => onMenuClick("/developer-task-history")}
            >
              <i className="fa fa-history" aria-hidden="true"></i>
              &nbsp;&nbsp; Developer Task History
            </Link>
          </li>

          {/* Team Report — live Today board + week/month real hours */}
          <li className="nav-item">
            <Link
              to="/team-report"
              className={`nav-link ${active === "/team-report" ? "active" : ""}`}
              onClick={() => onMenuClick("/team-report")}
            >
              <i className="fa fa-users" aria-hidden="true"></i>
              &nbsp;&nbsp; Team Report
            </Link>
          </li>

          {/* Activity Log — one developer's day as a story timeline */}
          <li className="nav-item">
            <Link
              to="/activity-log"
              className={`nav-link ${active === "/activity-log" ? "active" : ""}`}
              onClick={() => onMenuClick("/activity-log")}
            >
              <i className="fa fa-list-alt" aria-hidden="true"></i>
              &nbsp;&nbsp; Activity Log
            </Link>
          </li>
        </ul>
      </li>
    </>
  );
};

export default Workplace;
